import { render, staticRenderFns } from "./SendChatPopup.vue?vue&type=template&id=298f9ae9&scoped=true&"
import script from "./SendChatPopup.vue?vue&type=script&lang=ts&"
export * from "./SendChatPopup.vue?vue&type=script&lang=ts&"
import style0 from "./SendChatPopup.vue?vue&type=style&index=0&id=298f9ae9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298f9ae9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('298f9ae9')) {
      api.createRecord('298f9ae9', component.options)
    } else {
      api.reload('298f9ae9', component.options)
    }
    module.hot.accept("./SendChatPopup.vue?vue&type=template&id=298f9ae9&scoped=true&", function () {
      api.rerender('298f9ae9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SAdmin/SendChatPopup.vue"
export default component.exports